(() => {
  if (window.__reiseRedesignInitialized) return;
  window.__reiseRedesignInitialized = true;
  const configuration = document.getElementById('rn-settings');
  if (!configuration) return;
  const settings = JSON.parse(configuration.textContent);
  const labels = settings.labels;
  const request = window.__reiseNativeFetch || window.fetch.bind(window);
  const money = value => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value / 100);
  const apiURL = route => `${route.replace(/\.js$/, '').replace(/\/$/, '')}.js`;
  const header = document.querySelector('[data-rn-header]');
  const toastElement = document.querySelector('[data-rn-toast]');
  const quickDialog = document.getElementById('rn-quick-product');
  const quickGuideDialog = document.getElementById('rn-quick-guide');
  const cartDialog = document.getElementById('rn-cart');
  let toastTimer;
  let currentProduct;
  let quickSizes = [];
  let quickGuideRequest;
  let previousScroll = window.scrollY;
  let ticking = false;
  let saved = [];
  try { saved = JSON.parse(localStorage.getItem('reise_saved_products') || '[]'); } catch {}

  function toast(message) {
    if (!toastElement) return;
    clearTimeout(toastTimer);
    toastElement.textContent = message;
    toastElement.hidden = false;
    toastTimer = setTimeout(() => { toastElement.hidden = true; }, 3200);
  }

  function headerState() {
    if (!header?.classList.contains('rn-header--home')) return;
    const open = Boolean(document.querySelector('.rn-dialog[open]'));
    const delta = window.scrollY - previousScroll;
    let hidden = header.classList.contains('is-hidden');
    if (Math.abs(delta) > 4) { hidden = delta > 0 && window.scrollY > 80; previousScroll = window.scrollY; }
    if (window.scrollY < 10) hidden = false;
    header.classList.toggle('is-solid', window.scrollY >= 10 || open);
    header.classList.toggle('is-hidden', !open && hidden);
    ticking = false;
  }

  function closeDialog(dialog, immediate = false) {
    if (dialog === menuDialog && dialog.open && !immediate) {
      if (!menuClosing) animateMenu(false);
      return;
    }
    if (dialog === menuDialog) {
      menuAnimation?.cancel();
      menuAnimation = null;
    }
    dialog?.close();
  }

  function openDialog(dialog, trigger) {
    if (!dialog) return;
    if (dialog.open) {
      if (dialog === menuDialog && menuClosing) animateMenu(true);
      return;
    }
    const previousDialog = trigger?.closest('.rn-dialog');
    if (previousDialog && previousDialog !== dialog) trigger = previousDialog.__rnTrigger;
    document.querySelectorAll('.rn-dialog[open]').forEach(open => closeDialog(open, true));
    dialog.__rnTrigger = trigger;
    dialog.showModal();
    trigger?.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    if (dialog === menuDialog) animateMenu(true, true);
    headerState();
  }

  const menuDialog = document.getElementById('rn-menu');
  const menuDesktop = matchMedia('(min-width: 900px)');
  const menuMotionPreference = matchMedia('(prefers-reduced-motion: reduce)');
  let menuGroups = [];
  const menuPanels = new Map();
  const menuPanelAnimations = new Map();
  let menuGroupEvents;
  let activeMenuGroup = null;
  let menuAnimation;
  let menuClosing = false;
  let menuHoverTimer;

  function animateMenu(opening, fresh = false) {
    const offscreen = `translate3d(-${menuDialog.offsetWidth}px, 0, 0)`;
    const from = fresh ? offscreen : getComputedStyle(menuDialog).transform;
    menuAnimation?.cancel();
    menuAnimation = null;
    menuClosing = !opening;
    menuDialog.toggleAttribute('data-rn-closing', !opening);
    if (menuMotionPreference.matches) {
      if (!opening) menuDialog.close();
      return;
    }
    const animation = menuDialog.animate([
      { transform: from },
      { transform: opening ? 'translate3d(0, 0, 0)' : offscreen }
    ], { duration: opening ? 400 : 280, easing: 'cubic-bezier(.2, .7, .2, 1)', fill: 'both' });
    menuAnimation = animation;
    animation.finished.then(() => {
      if (menuAnimation !== animation) return;
      if (!opening) menuDialog.close();
      animation.cancel();
      menuAnimation = null;
    }).catch(() => {});
  }

  function menuPath(group) {
    const path = [];
    while (group) {
      path.unshift(group);
      group = menuPanels.get(group)?.parent;
    }
    return path;
  }

  function syncMenuPanels() {
    if (!menuDialog) return;
    const active = activeMenuGroup;
    const path = menuPath(active);
    const layered = Boolean(active && !menuDesktop.matches);
    menuDialog.classList.toggle('has-submenu', path.length > 0);
    menuDialog.classList.toggle('has-nested-submenu', path.length > 1);
    menuDialog.querySelector('.rn-menu__main').inert = layered;
    menuGroups.forEach(group => {
      const { summary, panel } = menuPanels.get(group);
      const expanded = path.includes(group);
      summary.setAttribute('aria-expanded', String(expanded));
      panel.inert = !expanded || (layered && group !== active);
      panel.hidden = (!expanded && !menuPanelAnimations.has(group)) || (layered && expanded && group !== active && !menuPanelAnimations.has(active));
    });
  }

  function animateMenuPanel(group, opening) {
    const panel = menuPanels.get(group).panel;
    const previous = menuPanelAnimations.get(group);
    const offset = menuDesktop.matches ? 'translate3d(32px, 0, 0)' : 'translate3d(100%, 0, 0)';
    const from = previous ? { transform: getComputedStyle(panel).transform, opacity: getComputedStyle(panel).opacity }
      : { transform: opening ? offset : 'translate3d(0, 0, 0)', opacity: opening && menuDesktop.matches ? 0 : 1 };
    previous?.cancel();
    menuPanelAnimations.delete(group);
    if (menuMotionPreference.matches || !menuDialog.open) {
      group.open = opening;
      panel.style.removeProperty('z-index');
      return;
    }
    group.open = true;
    panel.hidden = false;
    panel.style.zIndex = opening ? '3' : '2';
    const animation = panel.animate([
      from,
      { transform: opening ? 'translate3d(0, 0, 0)' : offset, opacity: !opening && menuDesktop.matches ? 0 : 1 }
    ], { duration: opening ? 320 : 240, easing: 'cubic-bezier(.2, .7, .2, 1)', fill: 'both' });
    menuPanelAnimations.set(group, animation);
    animation.finished.then(() => {
      if (menuPanelAnimations.get(group) !== animation) return;
      group.open = menuPath(activeMenuGroup).includes(group);
      animation.cancel();
      menuPanelAnimations.delete(group);
      panel.style.removeProperty('z-index');
      syncMenuPanels();
    }).catch(() => {});
  }

  function settleMenuPanels() {
    menuPanelAnimations.forEach(animation => animation.cancel());
    menuPanelAnimations.clear();
    const path = menuPath(activeMenuGroup);
    menuGroups.forEach(group => {
      group.open = path.includes(group);
      menuPanels.get(group).panel.style.removeProperty('z-index');
    });
    syncMenuPanels();
  }

  function selectMenuGroup(group, opening, moveFocus = false) {
    clearTimeout(menuHoverTimer);
    if (menuClosing) return;
    if (opening && group === activeMenuGroup && !moveFocus) return;
    const previousPath = menuPath(activeMenuGroup);
    const wasOpen = previousPath.includes(group);
    activeMenuGroup = opening ? group : menuPanels.get(group)?.parent || null;
    const path = menuPath(activeMenuGroup);
    menuGroups.forEach(item => {
      if (path.includes(item)) {
        if (!previousPath.includes(item)) animateMenuPanel(item, true);
      } else if (previousPath.includes(item)) animateMenuPanel(item, false);
    });
    syncMenuPanels();
    if (opening) {
      const panel = menuPanels.get(group).panel;
      if (!wasOpen || moveFocus) panel.scrollTop = 0;
      if (moveFocus) {
        const target = menuDesktop.matches ? panel.querySelector('a, summary') : panel.querySelector('[data-rn-menu-back]');
        target?.focus({ preventScroll: true });
      }
    } else if (moveFocus) {
      menuPanels.get(group).summary.focus({ preventScroll: true });
    }
  }

  function restoreMenuPanels() {
    clearTimeout(menuHoverTimer);
    menuPanelAnimations.forEach(animation => animation.cancel());
    menuPanelAnimations.clear();
    menuPanels.forEach(({ panel, marker, summary }, group) => {
      group.open = false;
      panel.hidden = false;
      panel.inert = false;
      panel.style.removeProperty('z-index');
      panel.style.removeProperty('--rn-menu-level');
      panel.removeAttribute('data-rn-menu-panel');
      summary.setAttribute('aria-expanded', 'false');
      marker.replaceWith(panel);
    });
    menuPanels.clear();
  }

  function bindMenuGroups() {
    menuGroupEvents?.abort();
    menuGroupEvents = new AbortController();
    const listenerOptions = { signal: menuGroupEvents.signal };
    restoreMenuPanels();
    activeMenuGroup = null;
    menuGroups = [...(menuDialog?.querySelectorAll('[data-rn-menu-group]') || [])];
    menuGroups.forEach(group => {
      const panel = group.querySelector(':scope > .rn-menu__children');
      const summary = group.querySelector(':scope > summary');
      const marker = document.createComment('');
      const parent = group.parentElement.closest('[data-rn-menu-group]');
      panel.before(marker);
      menuPanels.set(group, { panel, summary, marker, parent });
    });
    menuGroups.forEach(group => {
      group.open = false;
      const { summary, panel } = menuPanels.get(group);
      panel.dataset.rnMenuPanel = '';
      panel.style.setProperty('--rn-menu-level', menuPath(group).length);
      summary.id = `${panel.id}-trigger`;
      panel.setAttribute('role', 'group');
      panel.setAttribute('aria-labelledby', summary.id);
      menuDialog.querySelector('.rn-menu__body').append(panel);
      summary.addEventListener('click', event => {
        event.preventDefault();
        selectMenuGroup(group, menuDesktop.matches || group !== activeMenuGroup, !menuDesktop.matches || event.detail === 0);
      }, listenerOptions);
      summary.addEventListener('pointerenter', event => {
        if (!menuDesktop.matches || event.pointerType !== 'mouse') return;
        clearTimeout(menuHoverTimer);
        menuHoverTimer = setTimeout(() => {
          if (menuDialog.open && summary.matches(':hover')) selectMenuGroup(group, true);
        }, 150);
      }, listenerOptions);
      summary.addEventListener('pointerleave', () => clearTimeout(menuHoverTimer), listenerOptions);
      summary.addEventListener('keydown', event => {
        if (event.key !== 'ArrowRight') return;
        event.preventDefault();
        selectMenuGroup(group, true, true);
      }, listenerOptions);
      panel.querySelector('[data-rn-menu-back]').addEventListener('click', () => selectMenuGroup(group, false, true), listenerOptions);
      panel.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft') return;
        event.preventDefault();
        selectMenuGroup(group, false, true);
      }, listenerOptions);
    });
    syncMenuPanels();
  }
  bindMenuGroups();
  const searchBindings = new WeakMap();
  function bindSearchPanels(root = document) {
    root.querySelectorAll('[data-rn-search-panel]').forEach(panel => {
      if (searchBindings.has(panel)) return;
      const input = panel.querySelector('input[type="search"]');
      const form = panel.querySelector('form');
      const defaults = panel.querySelector('[data-rn-search-default]');
      const results = panel.querySelector('[data-rn-search-results]');
      const status = panel.querySelector('[data-rn-search-status]');
      if (!input || !form || !results || !status) return;
      const events = new AbortController();
      let timer;
      let pending;
      let revision = 0;
      const cancel = () => {
        clearTimeout(timer);
        pending?.abort();
        revision += 1;
      };
      const update = () => {
        cancel();
        const query = input.value.trim();
        if (defaults) defaults.hidden = Boolean(query);
        results.hidden = !query;
        results.replaceChildren();
        results.setAttribute('aria-busy', String(Boolean(query)));
        status.classList.remove('rn-sr-only');
        status.textContent = query ? panel.dataset.rnSearchLoading : '';
        if (!query) return;
        const currentRevision = revision;
        timer = setTimeout(async () => {
          pending = new AbortController();
          try {
            const url = new URL(panel.dataset.rnSearchUrl, location.origin);
            url.search = new URLSearchParams({ q: query, 'resources[type]': 'product', 'resources[limit]': '8', section_id: 'reise-predictive-search' });
            const response = await request(url, { signal: pending.signal });
            if (!response.ok) throw new Error(`Search: ${response.status}`);
            const html = await response.text();
            if (revision !== currentRevision || !panel.isConnected) return;
            const content = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-rn-search-response]');
            if (!content) throw new Error('Missing search results');
            results.replaceChildren(content);
            content.dispatchEvent(new CustomEvent('reise:products-loaded', { bubbles: true }));
            status.classList.add('rn-sr-only');
            status.textContent = content.dataset.rnSearchAnnouncement;
          } catch (error) {
            if (error.name === 'AbortError' || revision !== currentRevision || !panel.isConnected) return;
            status.textContent = panel.dataset.rnSearchError;
            const link = document.createElement('a');
            const url = new URL(form.action);
            url.search = new URLSearchParams(new FormData(form));
            link.href = url.href;
            link.className = 'rn-search__all';
            link.textContent = panel.dataset.rnSearchMore;
            results.replaceChildren(link);
          } finally {
            if (revision === currentRevision) results.setAttribute('aria-busy', 'false');
          }
        }, 220);
      };
      input.addEventListener('input', event => { if (!event.isComposing) update(); }, { signal: events.signal });
      input.addEventListener('compositionend', update, { signal: events.signal });
      input.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || event.isComposing) return;
        event.preventDefault();
        panel.closest('dialog')?.close();
      }, { signal: events.signal });
      form.addEventListener('reset', () => queueMicrotask(update), { signal: events.signal });
      const reset = () => {
        input.value = '';
        update();
        const dialog = panel.closest('dialog');
        if (dialog) dialog.scrollTop = 0;
      };
      panel.closest('dialog')?.addEventListener('close', reset, { signal: events.signal });
      window.addEventListener('pagehide', reset, { signal: events.signal });
      searchBindings.set(panel, () => { cancel(); events.abort(); searchBindings.delete(panel); });
      reset();
    });
  }
  bindSearchPanels();
  document.addEventListener('shopify:section:load', event => {
    bindSearchPanels(event.target);
    const searchPanel = event.target.querySelector('[data-rn-search-panel]');
    if (searchPanel?.closest('dialog')?.open) searchPanel.querySelector('input[type="search"]')?.focus({ preventScroll: true });
    if (!event.target.querySelector('[data-rn-side-menu]')) return;
    bindMenuGroups();
    if (menuDialog.open && document.activeElement === document.body) menuDialog.querySelector('.rn-menu__search').focus({ preventScroll: true });
  });
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-rn-search-panel]').forEach(panel => searchBindings.get(panel)?.());
    if (!event.target.querySelector('[data-rn-side-menu]')) return;
    menuGroupEvents?.abort();
    restoreMenuPanels();
    menuGroups = [];
    activeMenuGroup = null;
    syncMenuPanels();
  });
  document.addEventListener('shopify:section:select', event => {
    if (event.target.querySelector('[data-rn-search-panel]')) openDialog(document.getElementById('rn-search'), header?.querySelector('[data-rn-dialog-open="rn-search"]'));
    if (event.target.querySelector('[data-rn-side-menu]')) openDialog(menuDialog, header?.querySelector('[data-rn-dialog-open="rn-menu"]'));
  });
  document.addEventListener('shopify:block:select', event => {
    const searchPanel = event.target.closest('[data-rn-search-panel]');
    if (searchPanel) {
      openDialog(searchPanel.closest('dialog'), header?.querySelector('[data-rn-dialog-open="rn-search"]'));
      return;
    }
    const entry = event.target.closest('[data-rn-menu-entry]');
    if (!entry || !menuDialog?.contains(entry)) return;
    openDialog(menuDialog, header?.querySelector('[data-rn-dialog-open="rn-menu"]'));
    const group = entry.querySelector('[data-rn-menu-group]');
    if (group) selectMenuGroup(group, true);
    else if (activeMenuGroup) selectMenuGroup(menuPath(activeMenuGroup)[0], false);
  });
  menuDesktop.addEventListener('change', () => {
    const active = activeMenuGroup;
    const focused = document.activeElement;
    settleMenuPanels();
    if (!active || !menuDialog.open) return;
    const panel = menuPanels.get(active).panel;
    if (focused === document.body || focused.inert || focused.closest('[inert]') || (menuDesktop.matches && focused.matches('[data-rn-menu-back]'))) {
      (menuDesktop.matches ? panel.querySelector('a, summary') : panel.querySelector('[data-rn-menu-back]'))?.focus({ preventScroll: true });
    }
  });
  menuMotionPreference.addEventListener('change', () => {
    if (!menuMotionPreference.matches) return;
    menuAnimation?.finish();
    settleMenuPanels();
  });
  menuDialog?.addEventListener('cancel', event => {
    event.preventDefault();
    if (activeMenuGroup) selectMenuGroup(activeMenuGroup, false, true);
    else closeDialog(menuDialog);
  });
  menuDialog?.addEventListener('close', () => {
    if (menuDialog.open) return;
    clearTimeout(menuHoverTimer);
    menuAnimation?.cancel();
    menuAnimation = null;
    menuClosing = false;
    menuDialog.removeAttribute('data-rn-closing');
    activeMenuGroup = null;
    settleMenuPanels();
  });
  syncMenuPanels();

  async function cartRequest(route, payload) {
    const response = await request(apiURL(route), payload ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) } : { headers: { Accept: 'application/json' }, cache: 'no-store' });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || labels.error);
    return data;
  }

  function synchronizeCart(cart) {
    document.querySelectorAll('[data-rn-cart-count]').forEach(element => { element.textContent = cart.item_count; });
    if (cartState && cartSignature(cartState) !== cartSignature(cart)) updateCartView(cart);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
  }

  async function addVariant(id, button) {
    const original = button?.textContent;
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    try {
      await cartRequest(settings.cartAddUrl || '/cart/add', { items: [{ id: Number(id), quantity: 1 }] });
      await openCartAfterAdd({ trigger: button });
      return true;
    } catch (error) {
      toast(error.message || labels.error);
      return false;
    } finally {
      if (button) { button.disabled = false; button.removeAttribute('aria-busy'); button.textContent = original; }
    }
  }

  function productOf(card) {
    const data = card?.querySelector('[data-rn-product-json]');
    return data ? JSON.parse(data.textContent) : null;
  }

  function selectQuickVariant() {
    const selector = quickDialog.querySelector('[data-rn-quick-variant]');
    const variant = currentProduct?.variants.find(item => String(item.id) === selector.value);
    const cents = variant?.price ?? currentProduct?.price ?? 0;
    const pix = Math.round(cents * (1 - settings.discountPix / 100));
    const price = quickDialog.querySelector('[data-rn-quick-price]');
    const current = document.createElement('span');
    current.textContent = `${money(pix)}${settings.discountPix > 0 ? ' no PIX' : ''}`;
    price.replaceChildren(current);
    const comparison = Number(variant ? variant.compare_at_price : currentProduct?.compare_at_price);
    const showComparison = Number.isFinite(comparison) && comparison > cents;
    price.classList.toggle('rn-quick__price--comparison', showComparison);
    if (showComparison) {
      const previous = document.createElement('s');
      previous.className = 'rn-quick__compare-price';
      if (price.dataset.regularPriceLabel) {
        const label = document.createElement('span');
        label.className = 'rn-sr-only';
        label.textContent = `${price.dataset.regularPriceLabel}: `;
        previous.append(label);
      }
      previous.append(document.createTextNode(money(comparison)));
      price.append(previous);
    }
    const button = quickDialog.querySelector('[data-rn-quick-add]');
    button.disabled = !currentProduct?.available || Boolean(variant && !variant.available);
    button.textContent = !currentProduct?.available ? labels.unavailable : labels.add;
    quickDialog.querySelectorAll('[data-rn-quick-select]').forEach(element => { element.setAttribute('aria-pressed', String(element.dataset.rnQuickSelect === selector.value)); });
  }

  function moveQuickGallery(direction) {
    const gallery = quickDialog.querySelector('[data-rn-quick-gallery]');
    const step = gallery.firstElementChild?.getBoundingClientRect().width || gallery.clientWidth;
    const next = (Math.round(gallery.scrollLeft / step) + direction) * step;
    gallery.scrollTo({ left: Math.max(0, Math.min(gallery.scrollWidth - gallery.clientWidth, next)), behavior: motionPreference.matches ? 'instant' : 'smooth' });
  }

  async function openQuickGuide(opener) {
    if (!currentProduct || !quickGuideDialog || quickGuideDialog.open) return;
    quickGuideRequest?.abort();
    const controller = new AbortController();
    quickGuideRequest = controller;
    const productId = currentProduct.id;
    const status = quickGuideDialog.querySelector('[data-rn-quick-guide-status]');
    const frame = quickGuideDialog.querySelector('[data-rn-quick-guide-frame]');
    status.textContent = status.dataset.loading;
    status.hidden = false;
    frame.hidden = true;
    quickGuideDialog.__rnTrigger = opener;
    opener.setAttribute('aria-expanded', 'true');
    quickGuideDialog.showModal();
    const timeout = setTimeout(() => controller.abort(), 10000);
    try {
      const lookup = new URL('https://vfr-v3-production.sizebay.technology/plugin/my-product-id');
      lookup.searchParams.set('sid', '');
      lookup.searchParams.set('permalink', `https://www.reise.com.br/products/${productId}`);
      const response = await request(lookup, { signal: controller.signal });
      if (!response.ok) throw new Error('Size guide lookup failed');
      const product = await response.json();
      if (!product.id) throw new Error('Size guide not found');
      if (controller.signal.aborted || !quickGuideDialog.open || currentProduct.id !== productId) return;
      const url = new URL('https://measurements-table.sizebay.technology/');
      url.searchParams.set('id', product.id);
      url.searchParams.set('tenantId', '6156');
      url.searchParams.set('lang', (document.documentElement.lang || 'pt').startsWith('pt') ? 'br' : 'en');
      url.searchParams.set('embed', 'true');
      url.searchParams.set('sizes', btoa(String.fromCharCode(...new TextEncoder().encode(JSON.stringify(quickSizes)))));
      frame.onload = () => { if (quickGuideDialog.open && quickGuideRequest === controller) status.hidden = true; };
      frame.src = url.href;
      frame.hidden = false;
    } catch {
      if (quickGuideDialog.open && quickGuideRequest === controller) status.textContent = status.dataset.error;
    } finally {
      clearTimeout(timeout);
    }
  }

  function quickProduct(card, trigger) {
    currentProduct = productOf(card);
    if (!currentProduct) return;
    quickGuideRequest?.abort();
    quickGuideDialog?.close();
    quickDialog.querySelector('[data-rn-quick-title]').textContent = currentProduct.display_title || currentProduct.title;
    const badge = quickDialog.querySelector('[data-rn-quick-badge]');
    badge.textContent = card.querySelector('.rn-card__badge')?.textContent.trim() || '';
    badge.hidden = !badge.textContent;
    const gallery = quickDialog.querySelector('[data-rn-quick-gallery]');
    gallery.replaceChildren();
    currentProduct.images.forEach((src, index) => { const image = document.createElement('img'); image.src = src; image.alt = currentProduct.title; image.width = 480; image.height = 640; image.loading = index < 3 ? 'eager' : 'lazy'; image.decoding = 'async'; gallery.append(image); });
    quickDialog.querySelector('.rn-quick__media').hidden = !currentProduct.images.length;
    quickDialog.querySelector('[data-rn-quick-color]').textContent = currentProduct.color || '';
    const link = quickDialog.querySelector('[data-rn-quick-link]');
    link.href = currentProduct.url;
    const selector = quickDialog.querySelector('[data-rn-quick-variant]');
    selector.replaceChildren(new Option(labels.choose, ''));
    const choices = quickDialog.querySelector('[data-rn-quick-options]');
    choices.replaceChildren();
    const sizeIndex = currentProduct.options.findIndex(option => /tamanho|size/i.test(typeof option === 'string' ? option : option.name));
    quickSizes = sizeIndex < 0 ? [] : [...new Set(currentProduct.variants.map(variant => variant.options[sizeIndex]))];
    quickDialog.querySelector('[data-rn-quick-guide]').hidden = quickSizes.length < 2;
    for (const variant of currentProduct.variants) {
      const option = new Option(`${variant.title}${variant.available ? '' : ` · ${labels.unavailable}`}`, String(variant.id));
      option.disabled = !variant.available;
      selector.append(option);
      const choice = document.createElement('button'); choice.type = 'button'; choice.className = 'rn-quick__option'; choice.dataset.rnQuickSelect = String(variant.id); choice.disabled = !variant.available; choice.textContent = sizeIndex >= 0 && quickSizes.length === currentProduct.variants.length ? variant.options[sizeIndex] : variant.title; choice.setAttribute('aria-label', variant.title); choice.setAttribute('aria-pressed', 'false'); choices.append(choice);
    }
    if (currentProduct.variants.length === 1 && currentProduct.variants[0].available) selector.value = String(currentProduct.variants[0].id);
    quickDialog.querySelector('.rn-quick__variants').hidden = currentProduct.variants.length === 1 && currentProduct.variants[0].title === 'Default Title';
    quickDialog.querySelector('[data-rn-quick-error]').hidden = true;
    selectQuickVariant();
    openDialog(quickDialog, trigger);
    gallery.scrollLeft = 0;
  }

  function applySaved() {
    document.querySelectorAll('[data-rn-save]').forEach(button => {
      const handle = button.closest('[data-rn-card]')?.dataset.productHandle;
      button.setAttribute('aria-pressed', String(saved.includes(handle)));
    });
  }

  const motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
  const motionSelector = '.reise-home-category, .reise-home-editorial__copy, .reise-home-look__image, .reise-home-look__grid .rn-card__media, .reise-home-best__heading, .reise-home-best__track > .rn-card:not([data-best-duplicate]), .reise-home-faq > h2, .reise-home-faq__list, .reise-home-manifesto__image, .reise-home-manifesto__copy, .rn-col__intro, .rn-col__grid > .rn-card, .rn-card-adapter > .rn-card, .rpc-product-grid .rn-card';
  const revealed = new WeakSet();
  const observed = new Set();
  const animations = new Map();
  const revealObserver = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
    entries.forEach(({ target, isIntersecting }) => {
      if (!isIntersecting) return;
      revealObserver.unobserve(target);
      observed.delete(target);
      revealed.add(target);
      if (motionPreference.matches || target.contains(document.activeElement)) return;
      const item = target.closest('.rn-card') || target;
      const index = Array.from(item.parentElement.children).indexOf(item);
      const columns = matchMedia('(max-width: 767px)').matches ? 2 : 4;
      const animation = target.animate([
        { opacity: .25, transform: 'translateY(12px)' },
        { opacity: 1, transform: 'translateY(0)' }
      ], { duration: 520, delay: index % columns * 45, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'backwards' });
      animations.set(target, animation);
      animation.onfinish = animation.oncancel = () => animations.delete(target);
    });
  }, { rootMargin: '0px 0px -24px 0px', threshold: .06 }) : null;

  function registerMotion(root = document) {
    if (!revealObserver || motionPreference.matches || window.Shopify?.designMode || typeof Element.prototype.animate !== 'function') return;
    const targets = Array.from(root.querySelectorAll(motionSelector));
    if (root.matches?.(motionSelector)) targets.unshift(root);
    targets.forEach(target => {
      if (revealed.has(target) || observed.has(target)) return;
      observed.add(target);
      revealObserver.observe(target);
    });
  }

  motionPreference.addEventListener('change', () => {
    if (motionPreference.matches) {
      revealObserver?.disconnect();
      observed.clear();
      animations.forEach(animation => animation.cancel());
      animations.clear();
    } else registerMotion();
  });
  document.addEventListener('reise:products-loaded', event => registerMotion(event.target));
  document.addEventListener('shopify:section:load', event => registerMotion(event.target));
  document.addEventListener('shopify:section:unload', event => {
    observed.forEach(target => {
      if (!event.target.contains(target)) return;
      revealObserver.unobserve(target);
      observed.delete(target);
    });
    animations.forEach((animation, target) => {
      if (event.target.contains(target)) animation.cancel();
    });
  });
  registerMotion();

  const cardImageDefaults = new WeakMap();

  function setCardImage(card, product, index) {
    const image = card?.querySelector('.rn-card__image');
    if (!image || !product?.images[index]) return;
    if (!cardImageDefaults.has(image)) cardImageDefaults.set(image, { src: image.getAttribute('src'), srcset: image.getAttribute('srcset') });
    const original = cardImageDefaults.get(image);
    let srcset = original.srcset;
    if (index !== 0) {
      const source = new URL(product.images[index], window.location.href);
      const maximum = Math.min(Number(product.image_widths?.[index]) || 1000, 1000);
      const widths = [240, 360, 533, 720, 1000].filter(width => width < maximum);
      widths.push(maximum);
      srcset = widths.map(width => {
        source.searchParams.set('width', width);
        return `${source.href} ${width}w`;
      }).join(', ');
    }
    if (srcset) image.setAttribute('srcset', srcset);
    else image.removeAttribute('srcset');
    image.src = index === 0 ? original.src || product.images[0] : product.images[index];
    card.dataset.imageIndex = index;
  }

  function stepImage(card, direction) {
    const product = productOf(card);
    if (!product?.images.length) return;
    const next = ((Number(card.dataset.imageIndex || 0) + direction) % product.images.length + product.images.length) % product.images.length;
    setCardImage(card, product, next);
  }

  const cartLabels = labels.cart;
  const cartRewards = cartDialog?.querySelector('[data-rn-cart-rewards]');
  const rewardSteps = [...(cartRewards?.querySelectorAll('[data-rn-reward-step]') || [])]
    .map(element => ({ element, threshold: Number(element.dataset.threshold), label: element.dataset.label }))
    .filter(step => Number.isFinite(step.threshold) && step.threshold > 0)
    .sort((a, b) => a.threshold - b.threshold);
  const rewardMaximum = Math.max(0, ...rewardSteps.map(step => step.threshold));
  let cartState = null;
  let cartLoading = false;
  let cartMutationBusy = false;
  let couponBusy = false;
  let couponLocked = false;
  let couponStatusVersion = 0;
  let selectedShipping = null;
  let shippingRequest = null;
  let cartReadVersion = 0;
  const cartPanels = [...(cartDialog?.querySelectorAll('.rn-cart__panel') || [])];
  let cartPanelTarget = null;
  let cartPanelAnimation;
  const cartSignature = cart => JSON.stringify([cart.total_price, (cart.items || []).map(item => [item.key, item.quantity, item.final_line_price]), cart.discount_codes || []]);

  function cartControls() {
    if (!cartDialog) return;
    const empty = !cartState?.items?.length;
    const busy = cartLoading || cartMutationBusy || couponBusy || Boolean(shippingRequest);
    cartRewards?.setAttribute('aria-busy', String(busy));
    cartDialog.querySelector('[name="checkout"]').disabled = empty || busy || couponLocked;
    cartDialog.querySelectorAll('[data-rn-cart-remove], [data-rn-cart-panel]').forEach(button => { button.disabled = empty || busy; });
    cartDialog.querySelectorAll('.rn-cart__entry input, .rn-cart__entry button').forEach(element => { element.disabled = empty || busy; });
    cartDialog.querySelectorAll('[data-rn-cart-quantity-step]').forEach(button => {
      const item = cartState?.items.find(line => line.key === button.dataset.rnCartKey);
      button.disabled = empty || busy || !item || isCartGift(item) || (Number(button.dataset.rnCartQuantityStep) < 0 && item.quantity <= 1);
    });
  }

  function cartSummary() {
    if (!cartState) return;
    const code = cartState.discount_codes?.find(discount => discount.applicable)?.code;
    cartDialog.querySelector('[data-rn-cart-coupon-label]').textContent = code || cartLabels.coupon_add;
    const shippingLabel = cartDialog.querySelector('[data-rn-cart-shipping-label]');
    if (selectedShipping) {
      const name = document.createElement('span'); name.className = 'rn-cart__shipping-name'; name.textContent = selectedShipping.name;
      const price = document.createElement('span'); price.className = 'rn-cart__shipping-price'; price.textContent = selectedShipping.cents === 0 ? cartLabels.free : money(selectedShipping.cents);
      shippingLabel.replaceChildren(name, document.createTextNode(' '), price);
      shippingLabel.title = shippingLabel.textContent;
      shippingLabel.classList.add('has-shipping');
    } else {
      shippingLabel.textContent = cartLabels.shipping_add;
      shippingLabel.removeAttribute('title');
      shippingLabel.classList.remove('has-shipping');
    }
    cartDialog.querySelector('[data-rn-cart-total-label]').textContent = selectedShipping ? cartLabels.estimated_total : cartLabels.total;
    cartDialog.querySelector('[data-rn-cart-total]').textContent = money(cartState.total_price + (selectedShipping?.cents || 0));
    cartControls();
  }

  function shippingFeedback(message = '', invalid = false) {
    const output = cartDialog.querySelector('[data-rn-cart-shipping-feedback]');
    output.textContent = message;
    output.hidden = !message;
    output.classList.toggle('is-error', invalid);
    cartDialog.querySelector('[name="zip"]').setAttribute('aria-invalid', String(invalid));
  }

  function clearShipping() {
    shippingRequest?.abort();
    shippingRequest = null;
    selectedShipping = null;
    cartDialog.querySelector('[data-rn-cart-rates]').replaceChildren();
    shippingFeedback();
    cartSummary();
  }

  function isCartGift(item) {
    const properties = item.properties || {};
    return properties._reise_gift === 'true' || properties._reise_gift_rule === 'cart_over_threshold' || Boolean(properties._cecilia_campaign_id);
  }

  function updateCartRewards(cart) {
    if (!cartRewards || !rewardMaximum) return;
    const items = Array.isArray(cart.items) ? cart.items : [];
    const giftTotal = items.filter(isCartGift).reduce((sum, item) => sum + Number(item.final_line_price ?? item.line_price ?? 0), 0);
    const cartTotal = Number(cart.total_price || 0);
    const subtotal = cartTotal > 0 || Number(cart.total_discount || 0) > 0
      ? Math.max(0, cartTotal - giftTotal)
      : items.filter(item => !isCartGift(item)).reduce((sum, item) => sum + Number(item.final_line_price ?? item.line_price ?? 0), 0);
    const next = rewardSteps.find(step => step.threshold > subtotal);
    const message = next
      ? cartRewards.dataset.remaining.replace('__AMOUNT__', money(next.threshold - subtotal)).replace('__BENEFIT__', next.label)
      : cartRewards.dataset.complete;
    const messageElement = cartRewards.querySelector('[data-rn-rewards-message]');
    if (messageElement.textContent !== message) messageElement.textContent = message;
    const progress = cartRewards.querySelector('[data-rn-rewards-progress]');
    progress.style.setProperty('--rn-reward-progress', String(Math.min(1, Math.max(0, subtotal / rewardMaximum))));
    progress.setAttribute('aria-valuenow', String(Math.min(subtotal, rewardMaximum)));
    progress.setAttribute('aria-valuetext', `${cartRewards.dataset.value.replace('__CURRENT__', money(subtotal)).replace('__TARGET__', money(rewardMaximum))} ${message}`);
    rewardSteps.forEach((step, index) => {
      const reached = subtotal >= step.threshold;
      step.element.classList.toggle('is-reached', reached);
      step.element.classList.toggle('is-last', index === rewardSteps.length - 1);
      step.element.style.order = String(index);
      step.element.style.setProperty('--rn-reward-offset', `${(step.threshold / rewardMaximum * rewardSteps.length - index) * 100}%`);
    });
    cartRewards.hidden = false;
  }

  function cartItemText(item) {
    const fullTitle = item.product_title || item.title;
    const model = /^Tênis\b/i.test(fullTitle) ? fullTitle.match(/\b(?:RS\s*Knit(?:\s+GT)?|RS\d+(?:\s+(?:Avant|GT))?|Phantom(?:\s+(?:Slip\s+On|Easy|Knit))?)\b/i) : null;
    const title = model ? `Tênis ${model[0]}` : fullTitle;
    const description = model ? fullTitle.replace(/^Tênis(?:\s+Casual)?\s+/i, '').replace(model[0], '').trim() : '';
    const normalized = value => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const options = (item.options_with_values || []).filter(option => option.value && option.value !== 'Default Title').map(option => {
      const name = normalized(option.name);
      if (/^(tamanho(?: do calcado)?|numeracao|shoe size|size)$/.test(name)) return `${cartLabels.size} ${option.value}`;
      if (/^(cor|colou?r)$/.test(name)) return normalized(description).includes(normalized(option.value)) ? '' : option.value;
      return `${option.name}: ${option.value}`;
    });
    if (!options.length && item.variant_title && item.variant_title !== 'Default Title') options.push(item.variant_title);
    return { title, options: [description, ...options].filter(Boolean).join(' · ') };
  }

  function cartQuantityButton(item, step) {
    const button = document.createElement('button'); button.type = 'button'; button.className = 'rn-cart__quantity-button'; button.textContent = step < 0 ? '−' : '+';
    button.dataset.rnCartQuantityStep = step; button.dataset.rnCartKey = item.key;
    button.setAttribute('aria-label', `${step < 0 ? cartLabels.quantity_less : cartLabels.quantity_more} ${item.product_title || item.title}`);
    return button;
  }

  async function changeCartItem(key, quantity, trigger) {
    if (couponBusy || cartLoading || cartMutationBusy || shippingRequest) return;
    const focused = document.activeElement === trigger;
    const step = trigger.dataset.rnCartQuantityStep;
    cartMutationBusy = true;
    clearShipping();
    cartControls();
    trigger.closest('.rn-cart__item')?.setAttribute('aria-busy', 'true');
    try {
      const cart = await cartRequest(settings.cartChangeUrl || '/cart/change', { id: key, quantity });
      updateCartView(cart);
      synchronizeCart(cart);
    } catch (error) {
      const status = cartDialog.querySelector('[data-rn-cart-status]'); status.textContent = error.message || labels.error; status.hidden = false;
    } finally {
      cartMutationBusy = false;
      cartDialog.querySelectorAll('.rn-cart__item[aria-busy]').forEach(row => row.removeAttribute('aria-busy'));
      cartControls();
      if (focused && cartDialog.open) {
        const replacement = [...cartDialog.querySelectorAll('[data-rn-cart-quantity-step]')].find(button => button.dataset.rnCartKey === key && button.dataset.rnCartQuantityStep === step && !button.disabled);
        const alternative = [...cartDialog.querySelectorAll('[data-rn-cart-quantity-step]')].find(button => button.dataset.rnCartKey === key && !button.disabled);
        (replacement || alternative || cartDialog.querySelector('[data-rn-cart-remove]:not(:disabled)') || cartDialog.querySelector('[data-rn-dialog-close]'))?.focus({ preventScroll: true });
      }
    }
  }

  function updateCartView(cart) {
    if (!cartDialog) return;
    const focusedQuantity = document.activeElement?.closest('[data-rn-cart-quantity-step]');
    const focusedKey = focusedQuantity?.dataset.rnCartKey;
    const focusedStep = focusedQuantity?.dataset.rnCartQuantityStep;
    if (cartState && cartSignature(cartState) !== cartSignature(cart)) clearShipping();
    cartState = cart;
    updateCartRewards(cart);
    const container = cartDialog.querySelector('[data-rn-cart-items]');
    container.replaceChildren();
    if (!cart.items.length) {
      const empty = document.createElement('p'); empty.textContent = labels.empty; container.append(empty);
      setCartPanel(null, false, true);
    }
    for (const item of cart.items) {
      const fullTitle = item.product_title || item.title;
      const text = cartItemText(item);
      const row = document.createElement('div'); row.className = 'rn-cart__item'; row.dataset.rnCartItem = item.key;
      const imageLink = document.createElement('a'); imageLink.className = 'rn-cart__image-link'; imageLink.href = item.url; imageLink.setAttribute('aria-label', fullTitle);
      const image = document.createElement('img'); image.src = item.image || item.featured_image?.url || cartDialog.dataset.rnCartFallbackImage; image.alt = fullTitle; image.width = 140; image.height = 175;
      imageLink.append(image);
      const information = document.createElement('div'); information.className = 'rn-cart__info';
      const link = document.createElement('a'); link.className = 'rn-cart__title'; link.href = item.url; link.textContent = text.title; link.title = fullTitle; link.setAttribute('aria-label', fullTitle);
      const options = document.createElement('p'); options.className = 'rn-cart__options'; options.textContent = text.options; options.hidden = !text.options;
      const finalPrice = item.final_line_price ?? (item.final_price ?? item.price) * item.quantity;
      const price = document.createElement('p'); price.className = 'rn-cart__price';
      if (Number.isFinite(item.original_line_price) && item.original_line_price > finalPrice) {
        const original = document.createElement('del'); original.className = 'rn-cart__was-price'; original.textContent = money(item.original_line_price); price.append(original);
      }
      const current = document.createElement('span'); current.textContent = finalPrice === 0 ? cartLabels.free : money(finalPrice); price.append(current);
      const actions = document.createElement('div'); actions.className = 'rn-cart__item-actions';
      const quantity = document.createElement('div'); quantity.className = 'rn-cart__quantity'; quantity.setAttribute('role', 'group'); quantity.setAttribute('aria-label', `${cartLabels.quantity} ${fullTitle}`);
      const less = cartQuantityButton(item, -1);
      const value = document.createElement('span'); value.className = 'rn-cart__quantity-value'; value.textContent = item.quantity;
      const more = cartQuantityButton(item, 1);
      quantity.append(less, value, more);
      const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'rn-cart__remove'; remove.textContent = labels.remove; remove.dataset.rnCartRemove = item.key; remove.setAttribute('aria-label', `${labels.remove} ${fullTitle}`);
      actions.append(quantity, remove);
      information.append(link, options, price, actions); row.append(imageLink, information); container.append(row);
    }
    document.querySelector('side-cart-visual-gift')?.updateCart?.(cart);
    const status = cartDialog.querySelector('[data-rn-cart-status]');
    status.hidden = true;
    const couponInput = cartDialog.querySelector('[name="reise_offer_code"]');
    // Synchronize initial native codes without overwriting a code the visitor is typing.
    if (!couponInput.value) {
      couponInput.value = cart.discount_codes?.find(discount => discount.applicable)?.code || '';
      couponInput.closest('reise-gift-coupon')?.renderActionState?.();
    }
    cartSummary();
    if (focusedKey && cartDialog.open && !cartMutationBusy) {
      const replacement = [...cartDialog.querySelectorAll('[data-rn-cart-quantity-step]')].find(button => button.dataset.rnCartKey === focusedKey && button.dataset.rnCartQuantityStep === focusedStep && !button.disabled);
      replacement?.focus({ preventScroll: true });
    }
  }

  async function renderCart() {
    if (!cartDialog) return;
    const version = ++cartReadVersion;
    const container = cartDialog.querySelector('[data-rn-cart-items]');
    cartLoading = true;
    container.setAttribute('aria-busy', 'true');
    cartControls();
    try {
      const cart = await cartRequest(settings.cartUrl || '/cart');
      if (version !== cartReadVersion) return;
      updateCartView(cart);
      synchronizeCart(cart);
    } catch (error) {
      if (version !== cartReadVersion) return;
      clearShipping();
      cartState = null;
      if (cartRewards) cartRewards.hidden = true;
      const status = cartDialog.querySelector('[data-rn-cart-status]');
      status.textContent = error.message || labels.error; status.hidden = false;
    } finally {
      if (version === cartReadVersion) {
        cartLoading = false;
        container.removeAttribute('aria-busy');
        cartControls();
      }
    }
  }

  function animateCartPanel(panel, opening, from, complete) {
    const offset = `translate3d(0, ${panel.offsetHeight}px, 0)`;
    const animation = panel.animate([
      from || { transform: opening ? offset : 'translate3d(0, 0, 0)', opacity: opening ? 0 : 1 },
      { transform: opening ? 'translate3d(0, 0, 0)' : offset, opacity: opening ? 1 : 0 }
    ], { duration: opening ? 320 : 200, easing: 'cubic-bezier(.2, .7, .2, 1)', fill: 'both' });
    cartPanelAnimation = animation;
    animation.finished.then(() => {
      if (cartPanelAnimation !== animation) return;
      animation.cancel();
      cartPanelAnimation = null;
      complete?.();
    }).catch(() => {});
  }

  function setCartPanel(name, moveFocus = true, immediate = false) {
    if (!cartDialog) return;
    const target = cartPanels.find(panel => panel.id === `rn-cart-${name}`);
    const visible = cartPanels.find(panel => !panel.hidden);
    const from = cartPanelAnimation && visible ? { transform: getComputedStyle(visible).transform, opacity: getComputedStyle(visible).opacity } : null;
    cartPanelAnimation?.cancel();
    cartPanelAnimation = null;
    cartPanelTarget = target ? name : null;
    cartDialog.querySelectorAll('[data-rn-cart-panel]').forEach(button => {
      button.setAttribute('aria-expanded', String(Boolean(target) && button.dataset.rnCartPanel === name));
    });
    cartPanels.forEach(panel => { panel.inert = true; });
    if (moveFocus && visible && visible !== target) {
      cartDialog.querySelector(`.rn-cart__summary [data-rn-cart-panel="${visible.id.replace('rn-cart-', '')}"]`)?.focus({ preventScroll: true });
    }
    const show = () => {
      cartPanels.forEach(panel => { panel.hidden = panel !== target; });
      if (!target) return;
      target.inert = false;
      if (cartDialog.open) {
        target.scrollIntoView({ block: 'nearest', behavior: 'instant' });
        if (moveFocus) target.querySelector('input')?.focus({ preventScroll: true });
      }
      if (!immediate && !motionPreference.matches && cartDialog.open) {
        animateCartPanel(target, true, visible === target ? from : null);
      }
    };
    if (immediate || motionPreference.matches || !cartDialog.open) {
      show();
    } else if (visible && visible !== target) {
      animateCartPanel(visible, false, from, show);
    } else {
      show();
    }
  }

  function toggleCartPanel(name) {
    setCartPanel(cartPanelTarget === name ? null : name);
  }

  function closeCartPanel(name) {
    if (cartPanelTarget === name) setCartPanel(null);
  }

  cartDialog?.addEventListener('close', () => setCartPanel(cartPanelTarget, false, true));
  motionPreference.addEventListener('change', () => {
    if (motionPreference.matches) setCartPanel(cartPanelTarget, false, true);
  });

  const provinceNames = { AC:'Acre', AL:'Alagoas', AP:'Amapá', AM:'Amazonas', BA:'Bahia', CE:'Ceará', DF:'Distrito Federal', ES:'Espírito Santo', GO:'Goiás', MA:'Maranhão', MT:'Mato Grosso', MS:'Mato Grosso do Sul', MG:'Minas Gerais', PA:'Pará', PB:'Paraíba', PR:'Paraná', PE:'Pernambuco', PI:'Piauí', RJ:'Rio de Janeiro', RN:'Rio Grande do Norte', RS:'Rio Grande do Sul', RO:'Rondônia', RR:'Roraima', SC:'Santa Catarina', SP:'São Paulo', SE:'Sergipe', TO:'Tocantins' };

  async function cartAddress(zip, signal) {
    const providers = window.__REISE_LOCAL_PREVIEW__ ? [{ url:`/__preview/cep/${zip}.json`, state:'uf' }] : [
      { url:`https://viacep.com.br/ws/${zip}/json/`, state:'uf' },
      { url:`https://brasilapi.com.br/api/cep/v1/${zip}`, state:'state' }
    ];
    for (const provider of providers) {
      const lookup = new AbortController();
      const abort = () => lookup.abort();
      signal.addEventListener('abort', abort, { once: true });
      const timeout = setTimeout(abort, 3500);
      try {
        const response = await request(provider.url, { credentials:'omit', signal:lookup.signal });
        if ([400,404,422].includes(response.status)) throw new Error('invalid-zip');
        if (!response.ok) throw new Error('lookup');
        const address = await response.json();
        const province = provinceNames[address[provider.state]];
        if (address.erro || !province) throw new Error('invalid-zip');
        return province;
      } catch (error) {
        if (signal.aborted || error.message === 'invalid-zip') throw error;
      } finally {
        clearTimeout(timeout);
        signal.removeEventListener('abort', abort);
      }
    }
    throw new Error('lookup');
  }

  function renderCartRates(rates) {
    const container = cartDialog.querySelector('[data-rn-cart-rates]');
    container.replaceChildren();
    selectedShipping = null;
    rates.forEach((rate, index) => {
      if (!['string', 'number'].includes(typeof rate.price) || String(rate.price).trim() === '' || typeof rate.name !== 'string') return;
      const cents = Math.round(Number(rate.price) * 100);
      if (!Number.isFinite(cents) || cents < 0 || (rate.currency && rate.currency !== 'BRL')) return;
      const choice = { cents, name: rate.presentment_name || rate.name };
      const row = document.createElement('label'); row.className = 'rn-cart__rate';
      const input = document.createElement('input'); input.type = 'radio'; input.name = 'rn-cart-shipping-rate'; input.value = String(index);
      const information = document.createElement('span'); information.textContent = choice.name;
      const days = Array.isArray(rate.delivery_days) ? Math.max(...rate.delivery_days.map(Number)) : 0;
      if (Number.isFinite(days) && days > 0) {
        const description = document.createElement('small'); description.textContent = cartLabels.delivery_days.replace('__DAYS__', days); information.append(description);
      }
      const price = document.createElement('strong'); price.textContent = cents === 0 ? cartLabels.free : money(cents);
      const selectRate = () => {
        if (!input.checked) return;
        selectedShipping = choice;
        cartSummary();
        closeCartPanel('shipping');
      };
      input.addEventListener('click', selectRate);
      input.addEventListener('change', selectRate);
      row.append(input, information, price); container.append(row);
    });
    shippingFeedback(container.children.length ? '' : cartLabels.shipping_empty);
    cartSummary();
    if (container.children.length) container.scrollIntoView({ block: 'nearest' });
  }

  async function calculateCartShipping(event) {
    event.preventDefault();
    if (!cartState?.items.length || couponBusy || cartLoading || cartMutationBusy) return;
    clearShipping();
    const form = event.currentTarget;
    const zip = form.elements.zip.value.replace(/\D/g, '');
    if (!/^\d{8}$/.test(zip) || (/^(\d)\1{7}$/.test(zip) && !(window.__REISE_LOCAL_PREVIEW__ && zip === '99999999'))) {
      shippingFeedback(cartLabels.zip_error, true); form.elements.zip.focus(); return;
    }
    const controller = new AbortController();
    shippingRequest = controller;
    const signature = cartSignature(cartState);
    const current = () => shippingRequest === controller && !controller.signal.aborted && cartSignature(cartState) === signature && form.elements.zip.value.replace(/\D/g, '') === zip;
    const timeout = setTimeout(() => controller.abort(), 20000);
    shippingFeedback(cartLabels.loading);
    cartControls();
    try {
      const province = await cartAddress(zip, controller.signal);
      if (!current()) return;
      const parameters = new URLSearchParams({ 'shipping_address[zip]':zip, 'shipping_address[country]':'Brazil', 'shipping_address[province]':province });
      const root = `${settings.cartUrl.replace(/\/$/, '')}/`;
      const prepare = await request(`${root}prepare_shipping_rates.json?${parameters}`, { method:'POST', headers:{ Accept:'application/json' }, signal:controller.signal });
      if (!prepare.ok) throw new Error('quote');
      let quote = null;
      for (let attempt = 0; attempt < 30; attempt++) {
        if (!current()) return;
        const response = await request(`${root}async_shipping_rates.json?${parameters}`, { headers:{ Accept:'application/json' }, cache:'no-store', signal:controller.signal });
        if (!response.ok) throw new Error('quote');
        quote = await response.json();
        if (quote !== null) break;
        await new Promise(resolve => setTimeout(resolve, 450));
      }
      if (!current()) return;
      if (!Array.isArray(quote?.shipping_rates)) throw new Error('quote');
      renderCartRates(quote.shipping_rates);
    } catch (error) {
      if (shippingRequest !== controller) return;
      shippingFeedback(error.message === 'invalid-zip' ? cartLabels.zip_error : cartLabels.shipping_error, true);
    } finally {
      clearTimeout(timeout);
      if (shippingRequest === controller) { shippingRequest = null; cartControls(); }
    }
  }

  cartDialog?.querySelector('[data-rn-cart-shipping-form]').addEventListener('submit', calculateCartShipping);
  cartDialog?.querySelector('[name="zip"]').addEventListener('input', event => {
    const digits = event.target.value.replace(/\D/g, '').slice(0,8);
    event.target.value = digits.length > 5 ? `${digits.slice(0,5)}-${digits.slice(5)}` : digits;
    clearShipping();
  });
  document.addEventListener('cart-update', event => {
    const cart = event.detail;
    if (!cart?.items) return;
    // A coupon response supersedes a GET started before the mutation.
    ++cartReadVersion;
    cartLoading = false;
    updateCartView(cart);
    cartDialog?.querySelector('[data-rn-cart-items]').removeAttribute('aria-busy');
    synchronizeCart(cart);
  });
  document.addEventListener('reise:coupon-status', event => {
    const version = ++couponStatusVersion;
    const completed = couponBusy && !event.detail.busy;
    couponBusy = event.detail.busy;
    couponLocked = event.detail.checkoutLocked;
    if (couponBusy) clearShipping();
    cartControls();
    const component = cartDialog?.querySelector('#rn-cart-coupon reise-gift-coupon');
    const code = String(event.detail.code || '').trim().toUpperCase();
    if (!completed || event.detail.type !== 'success' || !code || event.detail.message !== component?.dataset.appliedMessage) return;
    // Run after the coupon component has restored its input focus.
    queueMicrotask(() => setTimeout(() => {
      if (version !== couponStatusVersion || couponBusy || couponLocked || !cartDialog?.open || document.querySelector('[data-reise-gift-warning-dialog]')?.open) return;
      const applied = cartState?.discount_codes?.some(discount => discount.applicable && String(discount.code).trim().toUpperCase() === code);
      if (applied) closeCartPanel('coupon');
    }, 0));
  });
  window.addEventListener('cecilia-free-gift:cart-updated', event => {
    const cart = event.detail?.cart;
    if (!cart?.items) return;
    ++cartReadVersion;
    cartLoading = false;
    updateCartView(cart);
    cartDialog?.querySelector('[data-rn-cart-items]').removeAttribute('aria-busy');
    document.querySelectorAll('[data-rn-cart-count]').forEach(element => { element.textContent = cart.item_count; });
  });

  async function openCartAfterAdd(detail = {}) {
    if (!cartDialog) { location.assign(settings.cartUrl || '/cart'); return; }
    clearTimeout(toastTimer);
    if (toastElement) toastElement.hidden = true;
    const trigger = detail.trigger || document.activeElement;
    openDialog(cartDialog, trigger instanceof HTMLElement ? trigger : null);
    if (detail.cart?.items) {
      ++cartReadVersion;
      cartLoading = false;
      cartDialog.querySelector('[data-rn-cart-items]').removeAttribute('aria-busy');
      updateCartView(detail.cart);
      synchronizeCart(detail.cart);
    } else {
      await renderCart();
    }
  }
  function handleCartAdded(event) {
    if (!cartDialog) return;
    event.preventDefault();
    return openCartAfterAdd(event.detail || {});
  }
  document.addEventListener('reise:cart-added', handleCartAdded);
  document.addEventListener('reise:added-to-cart', handleCartAdded);

  document.addEventListener('click', async event => {
    const opener = event.target.closest('[data-rn-dialog-open]');
    if (opener) {
      event.preventDefault();
      openDialog(document.getElementById(opener.dataset.rnDialogOpen), opener);
      if (opener.dataset.rnDialogOpen === 'rn-cart') await renderCart();
      return;
    }
    const cartPanel = event.target.closest('[data-rn-cart-panel]');
    if (cartPanel) { toggleCartPanel(cartPanel.dataset.rnCartPanel, cartPanel); return; }
    const closer = event.target.closest('[data-rn-dialog-close]');
    if (closer) { closeDialog(closer.closest('dialog')); return; }
    const card = event.target.closest('[data-rn-card]');
    const variantChoice = event.target.closest('[data-rn-quick-select]');
    if (variantChoice) { quickDialog.querySelector('[data-rn-quick-variant]').value = variantChoice.dataset.rnQuickSelect; quickDialog.querySelector('[data-rn-quick-error]').hidden = true; selectQuickVariant(); return; }
    const quick = event.target.closest('[data-rn-quick-open]');
    if (quick) { event.preventDefault(); quickProduct(card, quick); return; }
    const add = event.target.closest('[data-rn-add-variant]');
    if (add) { event.preventDefault(); await addVariant(add.dataset.rnAddVariant, add); return; }
    const arrow = event.target.closest('[data-rn-image-step]');
    if (arrow) { event.preventDefault(); stepImage(card, Number(arrow.dataset.rnImageStep)); return; }
    const save = event.target.closest('[data-rn-save]');
    if (save) {
      const handle = card.dataset.productHandle;
      saved = saved.includes(handle) ? saved.filter(value => value !== handle) : [...saved, handle];
      try { localStorage.setItem('reise_saved_products', JSON.stringify(saved)); } catch {}
      applySaved();
      return;
    }
    const quantityStep = event.target.closest('[data-rn-cart-quantity-step]');
    if (quantityStep) {
      const item = cartState?.items.find(line => line.key === quantityStep.dataset.rnCartKey);
      if (item && !isCartGift(item)) await changeCartItem(item.key, Math.max(1, item.quantity + Number(quantityStep.dataset.rnCartQuantityStep)), quantityStep);
      return;
    }
    const remove = event.target.closest('[data-rn-cart-remove]');
    if (remove) await changeCartItem(remove.dataset.rnCartRemove, 0, remove);
  });

  document.querySelectorAll('.rn-dialog').forEach(dialog => {
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeDialog(dialog);
    });
    dialog.addEventListener('close', () => {
      if (dialog === menuDialog && dialog.open) return;
      dialog.__rnTrigger?.setAttribute('aria-expanded', 'false');
      if (!document.querySelector('dialog[open]')) {
        dialog.__rnTrigger?.focus({ preventScroll: true });
        if (dialog === quickDialog && document.activeElement !== dialog.__rnTrigger) {
          dialog.__rnTrigger?.closest('[data-rn-card]')?.querySelector('.rn-card__title a')?.focus({ preventScroll: true });
        }
        document.body.style.overflow = '';
      }
      headerState();
    });
  });

  const quickGallery = quickDialog.querySelector('[data-rn-quick-gallery]');
  quickGallery.addEventListener('keydown', event => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    moveQuickGallery(event.key === 'ArrowLeft' ? -1 : 1);
  });
  quickDialog.querySelector('[data-rn-quick-guide]').addEventListener('click', event => openQuickGuide(event.currentTarget));
  window.addEventListener('message', event => {
    const frame = quickGuideDialog?.querySelector('[data-rn-quick-guide-frame]');
    if (quickGuideDialog?.open && event.origin === 'https://measurements-table.sizebay.technology' && event.source === frame.contentWindow && event.data === 'close-fitting-room') quickGuideDialog.close();
  });
  quickGuideDialog?.addEventListener('close', () => {
    quickGuideRequest?.abort();
    const frame = quickGuideDialog.querySelector('[data-rn-quick-guide-frame]');
    frame.onload = null;
    frame.removeAttribute('src');
    frame.hidden = true;
    if (quickDialog.open) quickGuideDialog.__rnTrigger?.focus({ preventScroll: true });
  });
  quickDialog.addEventListener('close', () => { quickGuideRequest?.abort(); quickGuideDialog?.close(); });
  quickDialog.querySelector('[data-rn-quick-variant]').addEventListener('change', selectQuickVariant);
  quickDialog.querySelector('[data-rn-quick-form]').addEventListener('submit', async event => {
    event.preventDefault();
    const selector = quickDialog.querySelector('[data-rn-quick-variant]');
    if (!selector.value) {
      const error = quickDialog.querySelector('[data-rn-quick-error]'); error.textContent = labels.choose; error.hidden = false;
      quickDialog.querySelector('.rn-quick__option:not(:disabled)')?.focus();
      return;
    }
    const variant = currentProduct?.variants.find(item => String(item.id) === selector.value);
    if (!variant?.available) return;
    const variants = quickDialog.querySelector('.rn-quick__variants');
    variants.disabled = true;
    try {
      await addVariant(variant.id, quickDialog.querySelector('[data-rn-quick-add]'));
    } finally {
      variants.disabled = false;
    }
  });

  document.addEventListener('focusin', event => {
    animations.forEach((animation, target) => {
      if (target.contains(event.target)) animation.finish();
    });
    event.target.closest('.rn-card__swatch')?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  });

  if (document.body.classList.contains('template-collection')) {
    document.addEventListener('pointerover', event => {
      const card = event.target.closest('[data-rn-card]');
      if (!card || event.relatedTarget?.closest?.('[data-rn-card]') === card || !matchMedia('(hover:hover)').matches) return;
      const product = productOf(card); if (product?.images.length > 1) stepImage(card, 1);
    });
    document.addEventListener('pointerout', event => {
      const card = event.target.closest('[data-rn-card]');
      if (!card || event.relatedTarget?.closest?.('[data-rn-card]') === card) return;
      setCardImage(card, productOf(card), 0);
    });
  }

  if (window.__REISE_LOCAL_PREVIEW__) {
    document.getElementById('rn-newsletter')?.addEventListener('submit', async event => {
      event.preventDefault();
      if (!event.target.reportValidity()) return;
      try {
        const response = await request('/contact', { method: 'POST', body: new URLSearchParams(new FormData(event.target)) });
        const result = await response.json();
        toast(result.message);
      } catch { toast(labels.error); }
    });
  }

  window.addEventListener('scroll', () => {
    if (!ticking) { ticking = true; requestAnimationFrame(headerState); }
  }, { passive: true });
  document.addEventListener('reise:products-loaded', applySaved);
  document.addEventListener('shopify:section:load', applySaved);
  const catalogue = document.getElementById('MainContent');
  if (catalogue) {
    new MutationObserver(records => {
      const inserted = records.flatMap(record => Array.from(record.addedNodes)).filter(node =>
        node instanceof Element && (node.matches('[data-rn-card]') || node.querySelector('[data-rn-card]'))
      );
      inserted.forEach(node => node.dispatchEvent(new CustomEvent('reise:products-loaded', { bubbles: true })));
    }).observe(catalogue, { childList: true, subtree: true });
  }
  applySaved();
  headerState();
})();
